/* Zapply Global Javascript */

document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initReveals();
  initStaggers();
  initHeroEntrance();
  initStickyHeader();
  initAnnouncementRotator();
});

const prefersReducedMotion = window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initScrollAnimations() {
  const elements = document.querySelectorAll('.fade-in-up');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach(el => el.classList.add('visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  elements.forEach(el => observer.observe(el));
}

/* Single-element scroll reveals: [data-reveal], [data-reveal="left|right|scale"] */
function initReveals() {
  const elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  elements.forEach(el => observer.observe(el));
}

/* Staggered children: container with [data-stagger] (optional data-stagger-step in ms) */
function initStaggers() {
  const containers = document.querySelectorAll('[data-stagger]');
  if (!containers.length) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    containers.forEach(c => c.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const container = entry.target;
      const step = parseInt(container.dataset.staggerStep || '90', 10);
      Array.from(container.children).forEach((child, i) => {
        child.style.transitionDelay = (i * step) + 'ms';
      });
      container.classList.add('is-visible');
      observer.unobserve(container);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  containers.forEach(c => observer.observe(c));
}

/* Subtle hero entrance on load */
function initHeroEntrance() {
  const hero = document.querySelector('.hero-content');
  if (!hero || prefersReducedMotion) return;
  hero.style.opacity = '0';
  hero.style.transform = 'translateY(18px)';
  requestAnimationFrame(() => {
    hero.style.transition = 'opacity 0.9s cubic-bezier(0.16,1,0.3,1), transform 0.9s cubic-bezier(0.16,1,0.3,1)';
    hero.style.opacity = '1';
    hero.style.transform = 'translateY(0)';
  });
}

function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  });
}

function initAnnouncementRotator() {
  const announcements = document.querySelectorAll('.announcement-msg');
  if (announcements.length <= 1) return;
  
  let currentIndex = 0;
  
  setInterval(() => {
    announcements[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % announcements.length;
    announcements[currentIndex].classList.add('active');
  }, 4000);
}
